import { Component, ComponentFactoryResolver, ViewContainerRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParadasComponent } from './paradas/paradas.component';
import { MapaComponent } from './mapa/mapa.component';
import { MapaContainerComponent } from './mapaContainer/mapaContainer.component';
import { TarifasComponent } from './tarifas/tarifas.component';
import { HorariosComponent } from './horarios/horarios.component';
import { TraduccionesComponent } from '../../../Alsa-MA-Angular-utils/src/app/traducciones.component';
import { DomSanitizer} from '@angular/platform-browser';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var i18nVS: any;
declare var portletNameServiceInformationLiferay: any; // Nombre del portlet en Liferay
declare var nombreOrigen: any;
declare var nombreDestino: any;
declare var colorLineaClicada: any;

declare function hideRatesSchedules();

// El modo ya no se usa
declare var modoLiferay: any; // Este valor nos indicara si estamos mirando // 1: Lineas, 2: Horarios, 3: Tarifas

/*--------------------------------------------- Variables Globales ----------------------------------------------*/
declare var IDLineaClicada: any;
declare var nombreLineaClicada: any;
var mapLoad = false;

@Component({
  selector: 'app-service-information',
  templateUrl: './service-information.component.html',
  styleUrls: ['./service-information.component.css']
})

export class AppComponent {
    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    i18nL = TraduccionesComponent.arrayTraducciones;

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    @ViewChild(ParadasComponent) childParadas: ParadasComponent; // Para tener acceso a las funciones de este componente
    @ViewChild(HorariosComponent) childHorarios: HorariosComponent; // Para tener acceso a las funciones de este componente
    @ViewChild(TarifasComponent) childTarifas: TarifasComponent; // Para tener acceso a las funciones de este componente
    @ViewChild(MapaContainerComponent, { read: ViewContainerRef }) container; // Preparar el contenedor del mapa

    // El modo ya no se usa
    modo = 1; // 1: Paradas, 2: Horarios, 3: Tarifas

    // Clases
    lineasClass = 'visible';
    paradasClass = 'invisible';
    errorEnLosWebservicesClass = 'invisible';

    icono = '';
    idLinea = -1;
    numberLinea = -1;

    titulo = this.i18nL.alsa_lineas;
    subtitulo = this.i18nL.serviceInformation_selecionLinea;

    origen = '';
    destino = '';

    portletName = ''; // Nombre del portlet
    /*----------------------------------------------- Funciones ----------------------------------------------------*/
    public setTraducciones() {
        if (typeof i18nVS !== 'undefined') { // Para saber si Liferay esta disponible o no
            this.i18nL = i18nVS;
            this.titulo = this.i18nL.alsa_lineas;
            this.subtitulo = this.i18nL.serviceInformation_selecionLinea;
            this.modo = modoLiferay; // Esto nos dice si nos encontramos en Lineas, Tarifas u Horarios

            if (this.modo === 1) { // Modo lineas
                this.titulo = this.i18nL.alsa_lineas;
                } else {
                    if (this.modo === 2) { // Modo horarios
                    this.titulo = this.i18nL.alsa_horarios;
                    this.icono = 'horarios';
                } else { // Modo tarifas
                    this.titulo = this.i18nL.alsa_tarifas;
                    this.icono = 'tarifas';
                }
            }
        }
    }

    public goToLineas() {
        this.tabControl(1);
        IDLineaClicada = -1;
        nombreLineaClicada = -1;
        if (typeof hideRatesSchedules != "undefined") {
        	hideRatesSchedules();
        }
    }

    public goToSchedules() {
        (<HTMLDivElement>document.getElementById("scheduleSection")).scrollIntoView();
    }

    public goToPrices(){
        (<HTMLDivElement>document.getElementById("scheduleSection")).scrollIntoView();
    }

    public callParadas(line) {
        this.childParadas.showStops(line);
        this.tabControl(2);

        // Ahora al llamar a paradas tambien se llama al resto de modulos
        this.childTarifas.PoblarVariables(this.idLinea);
        this.childHorarios.PoblarVariables(this.idLinea);
        this.callMap();
    }

    public callMap() {
        if (!mapLoad) {
            mapLoad = true;
            this.createComponents(MapaComponent);
        }
    }

    public createComponents(component) {
        const factory = this.componentFactoryResolver.resolveComponentFactory(component);
        const ref = this.container.createComponent(factory, 0);

        ref.changeDetectorRef.detectChanges();
    }

    public removeMap() {
        if (mapLoad) {
            // Esto elimina el primer componente creado dinamicamente, en este caso sera siempre el mapa
            this.container.remove(0);
            mapLoad = false;
        }
    }

    public tabControl(tab) { // 1 - lineas, 2 - paradas

        // Si se clica el boton de ir atras se volveran a mostrar las lineas
        if (tab !== 1) { // Si no estamos ya en lineas
            var url = window.location.href;
            if (url[url.length - 1] !== '#') { // Si la url no tenia ya la almohadilla
                console.log(2 + url[url.length - 1]);
                window.location.href = window.location.href + '#'; // Se le añade esto a la URL para que se pueda ir atras
            }
        }

        // Inicializamos
        this.lineasClass      = 'invisible';
        this.paradasClass     = 'invisible';

        switch (tab) {
            case 1: {
                this.lineasClass = 'visible';
                this.removeMap();
                break;
            }
            case 2: {
                this.paradasClass = 'visible';
                this.removeMap();
                break;
            }
            default: {
                console.log('Unregister tabControlLineas');
            }
        }

    }

    public onWebServiceError () {
        this.errorEnLosWebservicesClass = '';
        window.scrollTo(0, 0);
    }

    public poblarOrigenDestino() {
        this.origen = nombreOrigen;
        this.destino = nombreDestino;
    }

    public poblarOrigenDestinoCorrutine() {
        this.poblarOrigenDestino();
        setTimeout(() => this.poblarOrigenDestinoCorrutine(), 250);
    }

    public getBackground() {
        return this._sanitizer.bypassSecurityTrustStyle("#" + colorLineaClicada.replace("#",""));
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameServiceInformationLiferay;
        this.setTraducciones();
        this.tabControl(1);
        this.poblarOrigenDestinoCorrutine();
    }

    onLineSelected(line): void {
        colorLineaClicada = "#" + line.color.replace("#", "");
        this.idLinea = line.id;
        IDLineaClicada = line.id; // WA-4039
        nombreLineaClicada = line.name; // WA-4039
        this.numberLinea = line.name;
        // Ejemplo para distinguir los campos que contiene una linea. Ejemplo, la linea 1B:
        // El "id" es "ligne_1"
        // El "number" es "1"
        // El "name" es "1B"
        // El "surname" es "BOUKHALEF - MSNANA - BNI MAKADA"
        this.callParadas(line);
    }

    onLinesLoad(line) {
        this.childParadas.linesJson = line;
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private componentFactoryResolver: ComponentFactoryResolver,
        private viewContainerRef: ViewContainerRef, private http: HttpClient, private _sanitizer: DomSanitizer) {
    }
}



// WEBPACK FOOTER //
// ./src/app/service-information.component.ts